import * as React from "react";
export const useControlledValueWarning = isControlled => {
  const wasControlled = React.useRef(isControlled);
  React.useEffect(() => {
    if (wasControlled.current !== isControlled) {
      // eslint-disable-next-line no-console -- warn users about mixing up controlled & uncontrolled component funtionality
      console.warn(isControlled ? "Warning: A component is changing from uncontrolled to controlled state. This is likely caused by the value property being set and unset dynamically, which should not happen. Decide between using a controlled or uncontrolled state for the lifetime of the component." : "Warning: A component is changing from controlled to uncontrolled state. This is likely caused by the value property being set and unset dynamically, which should not happen. Decide between using a controlled or uncontrolled state for the lifetime of the component.");
    }
  }, [isControlled]);
};
export function useControlledValue(_ref) {
  let {
    isControlled,
    controlledValue,
    defaultValue,
    onChange
  } = _ref;
  const [stateValue, setValue] = React.useState(defaultValue);
  const value = isControlled ? controlledValue : stateValue;
  useControlledValueWarning(isControlled);
  const handleChange = React.useCallback(e => {
    if (!isControlled) {
      setValue(typeof value === "boolean" ? e.target?.checked : e.target.value);
    }
    onChange?.(e);
  }, [isControlled, onChange, value]);
  return {
    value,
    onChange: handleChange,
    setInternalValue: setValue
  };
}